import { Component } from "react";
import { routes } from "pages/routes";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";
import { Translation } from "react-i18next";
import { useUser } from "contexts/UserContext";
import { isMyExerciseList } from "pages/Exercises/urlState";

export default function MyExercisesSection(props) {
  const user = useUser();

  if (!user.instructor) {
    return null;
  }

  return (
    <Translation>
      {t => (
        <SidePanelSection
          sectionTitle={t("Common.labels.myExercises")}
          list={[
            {
              id: user.instructor.id,
              name: t("Common.labels.createdByMe"),
            },
          ]}
          location={props.location}
          tagName={MyExercisesListItem}
        />
      )}
    </Translation>
  );
}

class MyExercisesListItem extends Component {
  render() {
    const path = routes.exercisesByCreator.path({ creatorId: this.props.item.id });
    const isActive = isMyExerciseList(this.props.location);
    return (
      <li className={isActive ? "active" : ""}>
        <Link to={path}>{this.props.item.name}</Link>
      </li>
    );
  }
}
